module.exports = __webpack_public_path__ + "img/brand-white.cfe0bed8.png";